import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Icon, Link } from '../../atoms'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import * as Styled from './LinkList.styles'

/**
 * @returns {*}
 * @constructor
 */
const LinkList = ({ items, backLink }) => {
  const textContext = useContext(TextContext)

  return (
    <Styled.LinkListComponent>
      {/* optional back link */}
      {backLink && (
        <Link id={ backLink.id } to={ backLink.to } className='link back-link'>
          {textContext['navigation.backToSearchTreatment']}
        </Link>
      )}

      {/* link lists with optional title */}
      {items &&
        items.map((item, index) => (
          <div key={ index }>
            {item.title && (
              <p className={ 'list-title' } key={ index }>
                <b>{item.title}</b>
              </p>
            )}
            <ul>
              {item.linkList &&
                item.linkList.map((link, index) => (
                  <li key={ index }>
                    {link.url && (
                      <Link
                        id={ `${ index }` }
                        to={ link.url }
                        iconClass={ 'icon-f-arrow-right1 list-link-icon' }
                        className={ 'list-link' }>
                        <span className={ 'link-list-label' }>
                          {link.label}
                          {link.suffix && (
                            <b>
                              <br />
                              {link.suffix}
                            </b>
                          )}
                        </span>
                      </Link>
                    )}
                    {!link.url && (
                      <div id={ `${ index }` } className={ 'list-link' }>
                        <Icon
                          className={ 'icon-f-arrow-right1 list-link-icon' }
                        />
                        <span className={ 'link-list-label' }>
                          {link.label}
                          {link.suffix && (
                            <b>
                              <br />
                              {link.suffix}
                            </b>
                          )}
                        </span>
                      </div>
                    )}
                  </li>
                ))}
            </ul>
          </div>
        ))}
    </Styled.LinkListComponent>
  )
}

LinkList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      linkList: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          url: PropTypes.string,
        })
      ),
    })
  ),
  backLink: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
}

export default LinkList
